module.exports = new __parcel__URL__("Business Status Update Hover.d2aa938c.svg").toString();